import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { ADD_INVESTOR_INFO } from "./apiRoutes";

const mutateAddInvestorInfo = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${ADD_INVESTOR_INFO}/`, data);
};

const useAddInvestorInfoMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddInvestorInfo,
    ...queryParams,
  });

export default useAddInvestorInfoMutation;
